export const buildRangeString = (
  range?: null | {
    __typename?: string;
    min?: number | string | null;
    max?: number | string | null;
  }
) => {
  if (!range) return '-';
  return range.max
    ? `${range.min || '0'} - ${range.max || '0'}`
    : `From ${range.min || '0'}`;
};
